import axios from 'axios';
import { createContext, useEffect, useState } from 'react';
import { BASEURLAPI, DEFAULT_TRANSLATIONS } from './Constants';

// Otros contextos que ya tenías
export const GlobalContext = createContext({});
export const TimelineContext = createContext({});
export const ContextoReset = createContext({});

// Traducción
export const TranslationContext = createContext({
  translatedTexts: {},
  language: "ES",
  contextTranslate: {},
  setLanguage: () => {},
});

// 🔧 Utilidad para procesar traducciones por defecto
const getDefaultContextTranslate = () => {
  const fallback = {};
  DEFAULT_TRANSLATIONS.forEach((item) => {
    fallback[item.id] = {
      ES: item.ES,
      EN: item.EN,
      IT: item.IT,
      PT: item.PT,
    };
  });
  return fallback;
};

export const TranslationProvider = ({ children }) => {
  const [language, setLanguage] = useState("ES");
  const [translatedTexts, setTranslatedTexts] = useState({});
  const [contextTranslate, setContextTranslate] = useState(getDefaultContextTranslate());

  const getTranslations = async () => {
    console.log("actualizando traducciones");

    const fallback = getDefaultContextTranslate();
    setContextTranslate(fallback);
    
    // Comentamos la llamada a la API para evitar errores
    /*
    try {
      const res = await axios.get(BASEURLAPI + "/translations");

      if (res.status === 200 && res.data.status === "success") {
        const data = res?.data?.data;
        let apiContext = {};

        data.forEach((item) => {
          apiContext[item.id] = {
            ES: item.ES,
            EN: item.EN,
            IT: item.IT,
            PT: item.PT,
          };
        });

        // Mezclar traducciones locales con las de la API (la API tiene prioridad)
        const merged = { ...fallback, ...apiContext };

        setContextTranslate(merged);
        console.log("traducciones actualizadas", merged);
      } else {
        setContextTranslate(fallback);
      }
    } catch (error) {
      console.log("error al obtener traducciones", error);
      setContextTranslate(fallback);
    }
    */
  };

  useEffect(() => {
    getTranslations();
  }, []);

  useEffect(() => {
    if (!contextTranslate || typeof contextTranslate !== 'object') {
      setTranslatedTexts({});
      return;
    }
    
    const newTranslations = {};
    Object.keys(contextTranslate).forEach((key) => {
      if (contextTranslate[key] && typeof contextTranslate[key] === 'object') {
        newTranslations[key] = contextTranslate[key][language] || key;
      } else {
        newTranslations[key] = key;
      }
    });
    setTranslatedTexts(newTranslations);
  }, [language, contextTranslate]);

  return (
    <TranslationContext.Provider
      value={{ language, contextTranslate, translatedTexts, setLanguage }}
    >
      {children}
    </TranslationContext.Provider>
  );
};
